import { createContext, Dispatch, SetStateAction, ReactNode } from 'react';
import { useLocalStorage } from 'app/agriculture/hooks/useLocalStorage/useLocalStorage';
import { EntityType, EntityTypeEnum } from 'app/agriculture/models/Entities';

export const AgMapEntityVisibilityKey = 'AgMapEntityVisibility';

export const AllMapVisibility: EntityType[] = EntityTypeEnum.options;

export const DefaultMapVisibility: EntityType[] = AllMapVisibility;

export const ToggleableMapVisibility: EntityType[] = AllMapVisibility.filter((x) => {
    // we want to ensure some entities can't be toggled by the user
    const untoggleableMapEntities = [
        'Note',
        'Task',
        'Herd',
        'Paddock',
        'Boundary',
        'Animal',
        'ProtagAnimal',
        'Device',
    ];
    return !untoggleableMapEntities.includes(x);
});

interface MapVisibilityContextType {
    storedVisibility: EntityType[];
    setStoredVisibility: Dispatch<SetStateAction<EntityType[]>>;
}

export const MapVisibilityContext = createContext<MapVisibilityContextType>(
    {} as MapVisibilityContextType,
);

export const MapVisibilityContextProvider = ({ children }: { children: ReactNode }) => {
    const [storedVisibility, setStoredVisibility] = useLocalStorage<EntityType[]>(
        AgMapEntityVisibilityKey,
        DefaultMapVisibility,
    );
    return (
        <MapVisibilityContext.Provider value={{ storedVisibility, setStoredVisibility }}>
            {children}
        </MapVisibilityContext.Provider>
    );
};
